import { cn } from '@/utils/ui-utils';

export default function PageActions({
  leftActions,
  rightActions,
  centerContent,
  belowPageHeader = false,
}: {
  leftActions?: React.ReactNode[];
  rightActions?: React.ReactNode[];
  /** Rendered centered in the row regardless of how wide leftActions/rightActions are, e.g. a page title. */
  centerContent?: React.ReactNode;
  /** Set when a <PageHeader> is rendered directly above this instance, so the sticky offset accounts for its height too. */
  belowPageHeader?: boolean;
}) {
  return (
    <div
      className={cn(
        'bg-background sticky z-15 w-full print:hidden',
        belowPageHeader ? 'top-app-nav-bar' : 'top-app-nav',
      )}
    >
      {/* Page actions, e.g. buttons for filtering */}
      {leftActions || rightActions || centerContent ? (
        <div className='border-border mobile:px-4 relative flex h-page-bar items-center justify-between gap-4 border-b px-6'>
          {leftActions && leftActions.length > 0 && (
            <div className='flex h-full min-w-0 items-center gap-2'>{leftActions.map((element) => element)}</div>
          )}
          {centerContent && (
            <div className='pointer-events-none absolute inset-x-0 flex justify-center px-20'>
              <div className='pointer-events-auto truncate'>{centerContent}</div>
            </div>
          )}
          {rightActions && rightActions.length > 0 && (
            <div className='ml-auto flex h-full items-center justify-end gap-2'>
              {rightActions.map((element) => element)}
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
}
